import PropTypes from 'prop-types';

import './DropdownSubMenu.scss';

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {
  children: null,
};

function DropdownSubMenu({ children }) {
  return <div className="DropdownSubMenu">{children}</div>;
}

DropdownSubMenu.propTypes = propTypes;
DropdownSubMenu.defaultProps = defaultProps;

export default DropdownSubMenu;
